/* eslint-disable @typescript-eslint/no-explicit-any */
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { useWatch } from 'hooks';
import { useState } from 'react';

import { cn } from 'styles';

import { TabProviderProps, TabProvider as BaseProvider } from './context';

export function TabProvider({
  defaultValue,
  onTabChange,
  value,
  fullWidth = false,
  children,
  type = 'underline',
  contentFlow = 'top-to-bottom',
  className,
}: TabProviderProps) {
  const initialValue = value ?? defaultValue;

  const [tab, setTab] = useState(initialValue);

  const onChange = (newValue: string) => {
    setTab(newValue);
    onTabChange?.(newValue);
  };

  // Sync up, but do not trigger onTab!!
  useWatch(value, (newValue) => newValue && tab !== newValue && setTab(newValue));

  return (
    <TabsPrimitive.Root
      defaultValue={tab}
      value={tab}
      onValueChange={onChange}
      className={cn(
        {
          'w-full': fullWidth,
        },
        contentFlow === 'left-to-right' && 'relative flex gap-4',
        className,
      )}
    >
      <BaseProvider
        contentFlow={contentFlow}
        onTabChange={onChange}
        fullWidth={fullWidth}
        type={type}
        value={tab!}
      >
        {children}
      </BaseProvider>
    </TabsPrimitive.Root>
  );
}
